var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/bus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87868 4.87868C2.44129 4.31607 3.20435 4 4 4H17.6599C17.6599 4 17.66 4 17.6599 4C18.5515 3.99996 19.4175 4.29775 20.1204 4.8461C20.8234 5.39445 21.323 6.16193 21.5399 7.02667L22.61 11.2969C22.89 12.4146 22.89 13.5845 22.6101 14.7028L21.9697 17.2443C21.8577 17.6886 21.4582 18 21 18H19C18.4477 18 18 17.5523 18 17C18 16.4477 18.4477 16 19 16H20.2207L20.6699 14.2172C20.6699 14.2175 20.67 14.217 20.6699 14.2172C20.8699 13.4178 20.8699 12.5811 20.67 11.783L19.6001 7.51333C19.6 7.51325 19.6001 7.51342 19.6001 7.51333C19.4916 7.08107 19.2417 6.69717 18.8903 6.42305C18.5388 6.14887 18.1058 5.99997 17.6601 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V16H4C4.55228 16 5 16.4477 5 17C5 17.5523 4.55228 18 4 18H2C1.44772 18 1 17.5523 1 17V7C1 6.20435 1.31607 5.44129 1.87868 4.87868Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17C8 16.4477 8.44772 16 9 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H9C8.44772 18 8 17.5523 8 17Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 16C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5C8 16.6716 7.32843 16 6.5 16ZM3 17.5C3 15.567 4.567 14 6.5 14C8.433 14 10 15.567 10 17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16C15.6716 16 15 16.6716 15 17.5C15 18.3284 15.6716 19 16.5 19C17.3284 19 18 18.3284 18 17.5C18 16.6716 17.3284 16 16.5 16ZM13 17.5C13 15.567 14.567 14 16.5 14C18.433 14 20 15.567 20 17.5C20 19.433 18.433 21 16.5 21C14.567 21 13 19.433 13 17.5Z",
    fill: "#171717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.eb2c5be63834cac815b8ff9d2bff1f8a.svg";
export { ForwardRef as ReactComponent };